export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रस्तावक का खाता चुनें"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रस्तावक का खाता"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}